import { render, staticRenderFns } from "./progress-prioritization-column-header.vue?vue&type=template&id=e0336d7a&"
import script from "./progress-prioritization-column-header.vue?vue&type=script&lang=js&"
export * from "./progress-prioritization-column-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports